import  React, { Component } from 'react'
import { Modal, Input, message } from 'antd';

import './DefaultPassword.styl'
import { changePassword } from "@/api/login"

export default class DefaultPassword extends Component{
  state = {
    firstPassword: '',
    secondPassword: '',
    isShowFirstTips: false,
    isShowSecondTips: false,
    confirmLoading: false
  }

  render() {
    const { isShowFirstTips, isShowSecondTips, confirmLoading} = this.state;
    return (
      <div className="modify-email">
        <Modal
          title="首次登录请修改默认密码"
          visible={this.props.visible}
          onOk={this.handleOk}
          confirmLoading={confirmLoading}
          onCancel={this.handleCancel}
        >
          <Input.Password
            placeholder="请输入密码"
            prefix={<span className="icon iconfont icon-quanxian-23x"></span>}
            onChange={this.changeFirstPassword}
            onBlur={this.blurFirstPassword}
          />
          {
            isShowFirstTips ?
              <p className={`error-color fs-13`}>
                密码格式有误
              </p>
            :
              ''
          }
          <Input.Password
            className="m-t-10"
            placeholder="请再次输入密码"
            prefix={<span className="icon iconfont icon-quanxian-23x"></span>}
            onChange={this.changeSecondPassword}
            onBlur={this.blurSecondPassword}
          />
          {
            isShowSecondTips ?
              <p className="error-color fs-13">
                两次密码输入不一致
              </p>
            :
              ''
          }
          <p className="m-t-10 fs-13" style={{color: "rgba(0,0,0,.45)"}}>
            *：新的密码需要至少8个字符，其中包含至少1个大写字母，1个小写字母，1个数字和1个特殊字符
          </p>
        </Modal>
      </div>
    )
  }

  // 第一次输入密码
  changeFirstPassword = ({target: {value}}) => {
    if(value === '') {
      this.setState({isShowFirstTips: false});
    }
    this.setState({firstPassword: value});
  }
  blurFirstPassword = () => {
    if(this.state.firstPassword !== '') {
      const reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&.,])[A-Za-z\d$@$!%*?&.,]{8,}$/;
      this.setState({isShowFirstTips: !(reg.test(this.state.firstPassword))});
    }
  }
  // 第二次输入密码
  changeSecondPassword = ({target: {value}}) => {
    if(value === '') {
      this.setState({isShowSecondTips: false});
    }
    this.setState({secondPassword: value})
  }
  blurSecondPassword = () => {
    if(this.state.secondPassword !== '') {
      this.setState({isShowSecondTips: !(this.state.firstPassword === this.state.secondPassword)});
    }
  }

  /**
   * 确定修改默认密码
   */
  handleOk = () => {
    if(this.state.firstPassword === '') {
      message.warning("请输入密码");
      return
    }
    if(this.state.secondPassword === '') {
      message.warning("请再次输入密码");
      return
    }
    if(!this.state.isShowFirstTips && !this.state.isShowSecondTips) {
      this.setState({confirmLoading: true});
      changePassword({
        newPassword: this.state.firstPassword,
        oldPassword: this.state.secondPassword,
        username: this.props.user //第一次登录为账号密码登录时有效
      }).then(res => {
        this.setState({confirmLoading: false});
        this.handleCancel();
        message.success("修改成功，请使用新密码登录");
      }).catch(e => {
        this.setState({confirmLoading: false});
        message.error(e.message)
      })
    }
  }
  handleCancel = () => {
    this.setState({
      firstPassword: '',
      secondPassword: '',
      isShowFirstTips: false,
      isShowSecondTips: false,
    })
    this.props.handleCloseDefaultPasswordModal(false);
  }
}
